import React from 'react';
import { FormattedMessage } from 'react-intl';

import actions from './AddNewCategoryModal.actions';

import reduxStore from './../../../reduxStore';
import utils from './../../../utils/utilities';

import Modal from './../../Modal/Modal.index.jsx';
import Autocomplete from './../../Autocomplete/Autocomplete.index.jsx';

import { MAX_CATEGORY_NAME_LENGTH } from './../../../constants';

export default class AddNewCategoryModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = Object.assign(
            {},
            reduxStore.getState().addNewCategoryModal,
            {
                autocompleteCharacterCount: MAX_CATEGORY_NAME_LENGTH,
                autocompleteValue:          ''
            }
        );

        this.categoryNames = [];

        this.checkForInvalidCategoryName = this.checkForInvalidCategoryName.bind(this);
        this.onAutocompleteInputChange = this.onAutocompleteInputChange.bind(this);
        this.addNewCategoryHandler = this.addNewCategoryHandler.bind(this);
    }

    componentWillMount() {
        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(
                    Object.assign(
                        {},
                        reduxStore.getState().addNewCategoryModal
                    )
                );
            }
        );

        actions.resetToInitialState();

        // Store the category names in an array for easy usage with React Autosuggest
        this.categoryNames = [];
        for (let id in this.props.categories) {
            this.categoryNames.push(this.props.categories[id]);
        }
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    checkForInvalidCategoryName(name) {
        if (utils.inArray(name, this.categoryNames, null, value => value.toLowerCase()) > -1) {
            actions.setAddNewCategoryMessage('Entities_Review_UIText_reviewCompanies.categoryNameAlreadyExists');
        } else if (name.length === 0) {
            actions.setAddNewCategoryMessage('');
        } else if (name.length > MAX_CATEGORY_NAME_LENGTH) {
            actions.setAddNewCategoryMessage('Entities_Review_UIText_reviewCompanies.categoryMaxNameLengthExceeded');
        } else {
            actions.setAddNewCategoryMessage('Entities_Review_UIText_reviewCompanies.validCategoryName');
        }
    }

    onAutocompleteInputChange(autocompleteComponent, event, {newValue}) {

        let capitalizedValue = utils.capitalizeWords(newValue),
            characterCount   = MAX_CATEGORY_NAME_LENGTH - capitalizedValue.length;

        /*
         * This is required because the react-autosuggest input is controlled and you should change the state
         * of the Autocomplete component in order for the input to change its value.
         */
        autocompleteComponent.setState({value: capitalizedValue});

        this.checkForInvalidCategoryName(capitalizedValue.trim());

        // Update the character count and value
        this.setState({
            autocompleteCharacterCount: characterCount < 0 ? 0 : characterCount,
            autocompleteValue:          capitalizedValue
        });

    }

    addNewCategoryHandler() {
        this.props.addNewCategory(this.state.autocompleteValue.trim(), this.props.companies);
    }

    render() {
        let validationIconClass    = '',
            validationMessageClass = 'hidden';

        // Determine the classes that should be displayed for the validation icon and message
        switch (this.state.validationMessage) {
            case 'Entities_Review_UIText_reviewCompanies.validCategoryName':
                validationIconClass = 'la-Correct';
                validationMessageClass = 'valid';
                break;

            case '':
                validationIconClass = '';
                validationMessageClass = 'hidden';
                break;

            default:
                validationIconClass = 'la-Incorrect';
                validationMessageClass = 'invalid';
                break;
        }

        let buttons = [
            {
                text:       <FormattedMessage id="General_CoreFunctionality_UIText_general.save" />,
                primary:    true,
                isDisabled: validationMessageClass !== 'valid' ? true : false,
                click:      validationMessageClass !== 'valid' ? null : this.addNewCategoryHandler
            },
            {
                text:  <FormattedMessage id="General_CoreFunctionality_UIText_general.cancel" />,
                click: this.props.toggleAddNewCategoryModal
            }
        ];

        return (
            <Modal buttons={buttons} closeButtonHandler={this.props.toggleAddNewCategoryModal}>
                <h2 className="modal-header"><FormattedMessage id="Entities_Review_UIText_reviewCompanies.addNewCategory" /></h2>
                <div className="divider"></div>
                <div className="modal-body">
                    <p className="add-category-character-count">
                        {this.state.autocompleteCharacterCount}
                        &nbsp;
                        <FormattedMessage id="Entities_Review_UIText_reviewCompanies.charactersRemaining" />
                    </p>
                    <div className="add-category-wrapper">
                        <Autocomplete possibleValues={this.categoryNames}
                                      inputProps={
                                                     {
                                                         onChange: this.onAutocompleteInputChange,
                                                         maxLength: MAX_CATEGORY_NAME_LENGTH
                                                     }
                                                 } />
                        <span className={'add-category-validation-icon ' + validationIconClass}></span>
                    </div>
                    <p className={'add-category-validation-message ' + validationMessageClass }>
                        {this.state.validationMessage !== '' ?
                            <FormattedMessage id={this.state.validationMessage} /> : null}
                    </p>
                </div>
            </Modal>
        );

    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/ReusableModals/AddNewCategoryModal/AddNewCategoryModal.index.jsx